module.exports = __webpack_public_path__ + "static/img/banner.5831834.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner.jpg
// module id = omhf
// module chunks = 1